<template lang="pug">
  b-card.border-0.customerCard.tempInput(
    bg-variant="light",
    @click="selectTempHandler(originalData.id, originalData.type)"
  )
    .text-right.mb-2(
      v-if="deleteMode"
    )
      i.fas.fa-times-circle.fa-lg(
        @click.stop.prevent="deleteTempHandler(originalData.id, originalData.type)"
      )
    .row.mb-5
      .col-2.p-0.justify-content-center(
        v-show="selectMode"
      )
        input.custom_checker(
          type="checkbox",
          :id="`checkbox-group-${index}`",
          name="selectTemps",
          :checked="isChecked(index)"
          :class="{ 'hidden-check': isChecked(index) }"
        )
        .input_wrap.ml-3
          .custom-check-icon.border-black.mr-2
      .position-relative.chatBox(
        :class="{ 'col-10': selectMode, 'col-12': !selectMode }"
      )
        .chatBox__scrollBox
          .chatBox__carouselBox.d-inline-block.position-relative.w-100(
            style="white-space: nowrap;"
          )
            .carouselBox__bubble.d-inline-block.rounded.bg-white(
              v-for="(bubble,index) in originalData.push_format.bubbles",
              :class="{'w-100': originalData.push_format.bubbles.length === 1, 'mr-2': originalData.push_format.bubbles.length > 1 && originalData.push_format.bubbles.length !== index + 1}"
            )
              .bubble__upPart.position-relative.rounded-top(
                :class="{'d-flex': !bubble.image, 'align-items-center': !bubble.image, 'justify-content-center': !bubble.image, 'no-img-min-height': !bubble.image}"
              )
                i.fas.fa-image.fa-3x.text-muted.chatBox__imageBox-icon(
                  v-if="!bubble.image"
                )
                img.img-fluid.rounded-top(
                  v-else,
                  :src="bubble.image"
                )
              .bubble__downPart.position-relative.p-2.rounded-bottom
                span.d-block.mb-0.white-space-pre-line(
                  v-if="bubble.title === null || bubble.title === '' ",
                  :class="{ 'text-left': bubble.title_align === 'start', 'text-center': bubble.title_align === 'center', 'text-right': bubble.title_align === 'end' }", :style="{ color: bubble.title_color }")
                span.d-block.mb-0.white-space-pre-line(
                  v-if="bubble.title !== null",
                  :class="[{'text-left': bubble.title_align === 'start', 'text-center': bubble.title_align === 'center', 'text-right': bubble.title_align === 'end' }, titleFontSize(bubble.title_size)]",
                  :style="{ color: bubble.title_color }"
                ) {{ bubble.title }}
                span.d-block.defaultTextColor(
                  v-if="bubble.message === null || bubble.message === '' ",
                  :class="{ 'text-left': bubble.message_align === 'start', 'text-center': bubble.message_align === 'center', 'text-right': bubble.message_align === 'end' }",
                  :style="{ color: bubble.message_color }"
                )
                span.d-block.defaultTextColor.white-space-pre-line(
                  v-if=" bubble.message !== null",
                  :class="{ 'text-left': bubble.message_align === 'start', 'text-center': bubble.message_align === 'center', 'text-right': bubble.message_align === 'end' }",
                  :style="{ color: bubble.message_color }"
                ) {{ bubble.message }}
                hr(v-if="bubble.buttons.length > 0")
                .buttonBox.position-relative(
                  v-for="button in bubble.buttons",
                  v-if="bubble.buttons.length > 0"
                )
                  span.text-center.d-block.pb-1(
                    v-if="button.actionType === null || button.label === null"
                  ) 動作設定
                  span.text-center.d-block.pb-1(
                    v-if="button.actionType === 'message' && button.label !== null"
                  ) {{ button.label }}
                  a.text-center.d-block.pb-1.href-text(
                    v-if="button.actionType === 'uri' && button.label !== null",
                    :href="button.uri"
                  ) {{ button.label }}
    small.font-size-sm 建立者：{{ originalData.creator }}
    p.font-size-sm.mb-1 模板名稱：{{ originalData.name }}

</template>

<script>
const _ = require('lodash');

export default {
  name: 'carousel-input',
  props: {
    index: [String, Object, Number],
    // 父層資訊
    originalData: {
      type: Object,
      required: true
    },
    selectMode: {
      type: Boolean,
      default: false
    },
    selectTemps: {
      type: Array,
      default: () => [],
    },
    deleteMode: {
      type: Boolean,
      default: false,
    },
    tempTypes: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    selectTempHandler(id, template) {
      const vm = this;
      vm.$emit('selectTempHandler', {
        id,
        template
      });
    },
    deleteTempHandler(id, template) {
      const vm = this;
      vm.$emit('deleteTempHandler', {
        id,
        template
      });
    },
    titleFontSize(size) {
      return `title-font-size-${size}`;
    },
    isChecked(index) {
      const vm = this;
      const key = _.findKey(vm.selectTemps, (val) => val.id === vm.originalData.id && val.type === vm.originalData.type);
      if (key) {
        return true;
      }
      return false;
    }
  },
  computed: {
    order() {
      const vm = this;
      const key = _.findKey(vm.selectTemps, (val) => val.id === vm.originalData.id);
      return parseInt(key);
    },

  }
};
</script>

<style lang="scss" scoped>
.card {
  border: 0.2rem solid #000!important;
  border-radius: 0.8rem;
  box-shadow: 0.2rem 0.2rem 0 #00000033;
  &-hasNews {
    &::after {
      content: "";
      position: absolute;
      right: 0.4rem;
      top: 0.4rem;
      background-color: #ef4852;
      width: 0.7rem;
      height: 0.7rem;
      border-radius: 50%;
    }
  }
}
.chatBox {
  &__scrollBox {
    overflow-x: auto;
    // 整個 scrollbar
    &::-webkit-scrollbar {
      position: absolute;
      background-color: #f3f4fa;
      border-radius: 20px;
      height: 5px;
    }
    // 裡面那條
    &::-webkit-scrollbar-thumb {
      background-color: darkgrey;
      border-radius: 10px;
    }
    /*// scroll 背景*/
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }
    .chatBox__carouselBox {
      white-space: nowrap;
      width: 100%;
      height: auto;
      // 每一個 bubble
      .carouselBox__bubble {
        width: 90%;
        height: 100%;
        white-space: normal;
        background-color: #f3f4f7;
        display: inline-block;
        vertical-align: top;
        transition: all 0.8s ease;
        // bubble 上半部
        .bubble__upPart {
          min-height: 40%;
        }
        // bubble 下半部
        .bubble__downPart {
          height: 60%;
        }
        .bubble__upPart.no-img-min-height {
          min-height: 150px;
        }
        // 訊息預設顏色
        .defaultTextColor {
          color: #858585;
        }
      }
    }
  }
}

.bg-white {
  background-color: white;
}

@font-face {
  font-family: "icon";
  src: url("../../../assets/fonts/icon.eot?hrpp7d");
  src: url("../../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

i {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1rem;
  margin-bottom: 4px;
}

.iconClose:before {
  content: "\e908";
}

.border-black{
  border: 0.2rem solid #000;
}
.outline-invitation {
  display: block;
  border-radius: 1rem;
  padding: 1rem;
  cursor: pointer;
}
.custom-shadow {
  -webkit-box-shadow: 0.2rem 0.2rem 0 #00000033;
  box-shadow: 0.2rem 0.2rem 0 #00000033;
}

.custom-check-icon {
  width: 2rem;
  height: 2rem;
  background-color: #fff;
  border-radius: 0.4rem;
  margin-right: 1.2rem;
  position: relative;
}

.custom_checker:checked ~ .input_wrap .custom-check-icon {
  background-color: #ef4852;
}

.custom_checker:checked ~ .input_wrap .custom-check-icon::after {
  display: block;
}

.custom-check-icon::after {
  content: '';
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 1.5rem;
  height: 1rem;
  background-image: url(../../../assets/images/icon/check-1.png);
  background-size: 1.5rem;
  background-repeat: no-repeat;
}

.invitation_info {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

input[type="checkbox"], input[type="radio"] {
  position: absolute;
  width: 1px;
  height: 1px;
  display: none;
  opacity: 0;
}
</style>
